import apiHelper from './index';

async function getTaskCategories(organization, spinner = false) {
  const query = organization ? `?organization=${organization}` : '';
  return await apiHelper.get(`organization/task-categories/${query}`, spinner);
}

async function getTaskCategoryById(id, spinner = false) {
  return await apiHelper.get(`organization/task-categories/${id}/`, spinner);
}

async function createTaskCategory(payload, spinner = false) {
  return await apiHelper.post('organization/task-categories/', payload, spinner);
}

async function updateTaskCategory(id, payload, spinner = false) {
  return await apiHelper.patch(`organization/task-categories/${id}/`, payload, spinner);
}

async function deleteTaskCategory(id, spinner = false) {
  return await apiHelper.remove(`organization/task-categories/${id}/`, spinner);
}

export default {
  getTaskCategories,
  getTaskCategoryById,
  createTaskCategory,
  updateTaskCategory,
  deleteTaskCategory,
};
